// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___12TmX","open":"open___2yVpQ","mobileBlocker":"mobileBlocker___1JDMM","overlay":"overlay___3QXQ4"};